import { Tabs } from "djinn-components";
import React from "react";
import ProfileEdit from "../Forms/Account/EditProfileForm";
import NotificationsEdit from "../Forms/Account/NotificationsEdit";
import ThemePick from "../Forms/Account/ThemePick";

interface AccountProfileScreenProps {}

const AccountProfileScreen: React.FC<AccountProfileScreenProps> = () => {
  return (
    <main className="flex-1 relative z-0 overflow-y-auto">
      <div className="mt-5 max-w-5xl mx-auto flex justify-between bg-gray-600 rounded-lg p-10 relative">
        <Tabs
          defaultActive={0}
          tabs={[
            {
              title: "Profile",
              component: <ProfileEdit />,
            },
            {
              title: "Theme",
              component: <ThemePick />,
            },
            {
              title: "Notification Settings",
              component: <NotificationsEdit />,
            },
          ]}
        />
      </div>
    </main>
  );
};

export default AccountProfileScreen;
